import React from "react";
import { ComponentValidator } from "../../shared/validation";

const minNumColumns: number = 1;
const maxNumColumns: number = 3;

export const firstColumnIndex: number = 0;
export const secondColumnIndex: number = 1;
export const thirdColumnIndex: number = 2;

export const minBannerColumnsValidator = (columns: readonly React.ReactNode[]): ComponentValidator => (
    () => (columns.length < minNumColumns ? `Banner cannot have less than ${minNumColumns} column` : undefined)
);

export const maxBannerColumnsValidator = (columns: readonly React.ReactNode[]): ComponentValidator => (
    () => (columns.length > maxNumColumns ? `Banner cannot have more than ${maxNumColumns} column` : undefined)
);
